import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {StorageService} from '../../@core/services/storage.service';
import {
  AQH_MEM_0,
  AQH_MEM_1,
  AQH_MEM_2,
  AQH_MEM_3,
  AQH_MEM_4,
  _AQH_MEM_5,
  _AQH_MEM_6,
  _AQH_MEM_7,
  AQH_MEM_5,
  AQH_MEM_6,
  AQH_MEM_7
} from '../models/input.module';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  constructor(private endpointService: EndpointService,
              private storageService: StorageService) {
  }

  // User membership methods
  getUserMembership(params: AQH_MEM_0) {
    return this.endpointService.aqh_mem_0(params).pipe(map((data => {
      return data.data;
    })))
  }

  postMembership(params: AQH_MEM_1) {
    return this.endpointService.aqh_mem_1(params).pipe(map((data => {
      return data.data;
    })))
  }

  updateMembership(params: AQH_MEM_2) {
    return this.endpointService.aqh_mem_2(params).pipe(map((data => {
      return data.data;
    })))
  }

  cancelMembership(params: AQH_MEM_3) {
    return this.endpointService.aqh_mem_3(params).pipe(map((data => {
      return data;
    })))
  }

  // Membership plan methods
  getMembershipPlans(params: AQH_MEM_4) {
    return this.endpointService.aqh_mem_4(params).pipe(map((data => {
      return data.data;
    })))
  }

  createMembershipPlan(params: _AQH_MEM_5) {
    let payload: AQH_MEM_5 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    }
    return this.endpointService.aqh_mem_5(payload).pipe(map((data => {
      return data.data;
    })))
  }

  updateMembershipPlan(params: _AQH_MEM_6) {
    let payload: AQH_MEM_6 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    }
    return this.endpointService.aqh_mem_6(payload).pipe(map((data => {
      return data.data;
    })))
  }

  deleteMembershipPlan(params: _AQH_MEM_7) {
    let payload: AQH_MEM_7 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    }
    return this.endpointService.aqh_mem_7(payload).pipe(map((data => {
      return data;
    })))
  }
}
